import { render, staticRenderFns } from "./riskAssessmentCategory.vue?vue&type=template&id=6b266200"
import script from "./riskAssessmentCategory.vue?vue&type=script&lang=js"
export * from "./riskAssessmentCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports